import { SxProps, Theme } from '@mui/material/styles'
import { hoverBaseStyles } from '../base/hoverBase.styles'

export const notesPropsStyles = {
  root: {
    ...hoverBaseStyles.root,
  } as SxProps<Theme>,

  item: {
    ...hoverBaseStyles.textSemiBold,
    color: 'gray.64',
  } as SxProps<Theme>,
}
